/**
 * useNudgeContext — extracts route, query params, and goal for context-aware
 * nudge ordering (RFC-022). Passed to useSetupStatus so the most relevant
 * onboarding step is shown based on where the user is and how they arrived.
 */
import { useLocation } from 'react-router-dom'

export interface NudgeContext {
  /** Current route path */
  page: string
  /** Query params (utm_source, tab, from, etc.) */
  params: Record<string, string>
  /** Tenant's selected goal from RFC-013 (null if not set) */
  goal: 'find_buyers' | 'linkedin_presence' | 'market_research' | null
}

export function useNudgeContext(goal?: NudgeContext['goal']): NudgeContext {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)

  return {
    page: location.pathname,
    params: Object.fromEntries(searchParams.entries()),
    goal: goal ?? null,
  }
}
